import gql from 'graphql-tag'

import { NotificationFrequency } from '../../../../types/fam-graphql'
import { mutationServiceCreator } from '../../../../helpers/GraphqlHelpers'

const mutation = gql`
  mutation updateNotificationPreference(
    $should_receive_notifications: Boolean!
    $notification_frequency: NotificationFrequency
  ) {
    updateNotificationPreference(
      should_receive_notifications: $should_receive_notifications
      notification_frequency: $notification_frequency
    ) {
      should_receive_notifications
      notification_frequency
    }
  }
`

const transformer = ({ updateNotificationPreference }: any) =>
  updateNotificationPreference

type variables = {
  should_receive_notifications: boolean
  notification_frequency?: NotificationFrequency
}

export default mutationServiceCreator<variables>(mutation, transformer)
